import { StrictMode } from 'react';
import { ApplicationProvider } from '../contexts/application-context.jsx';
import { jsx, Fragment } from 'react/jsx-runtime';

function App({
  children,
  owner,
  providerOptions
}) {
  return /*#__PURE__*/jsx(StrictMode, {
    children: /*#__PURE__*/jsx(ApplicationProvider, {
      owner: owner,
      children: /*#__PURE__*/jsx(CustomProviders, {
        providerOptions: providerOptions,
        children: children
      })
    })
  });
}
function CustomProviders({
  children,
  providerOptions
}) {
  if (!providerOptions?.component) {
    return /*#__PURE__*/jsx(Fragment, {
      children: children
    });
  }
  const {
    component: Component,
    props = {}
  } = providerOptions;
  return /*#__PURE__*/jsx(Component, {
    ...props,
    children: children
  });
}

export { App };
//# sourceMappingURL=app.jsx.map
